import { useState, useEffect } from "react";
import { MdRefresh } from "react-icons/md";
import { useParams } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";
import AccountDetails from "../../Component/AccountDetails";
import { Button, Modal } from "react-bootstrap";
import CreatePayment from "../../Component/payments/CreatePayment";
import CreateBill from "../../Component/bills/CreateBill";
import BillsForAccount from "../../Component/bills/BillsForAccount";
import PaymentForAccount from "../../Component/payments/PaymentForAccount";
import HouseForAccount from "../../Component/Houses/HouseForAccount";
import UpdateAccountDetails from "../../Component/Accounts/UpdateAccountDetails";
import AccountOwner from "../../Component/Accounts/AccountOwner";
import { editBill, editPayment, editAccount } from "../../utils/roles?";
import { useFetchData } from "../../hooks/useFetchData";
import UpdateSubsriber from "../../Component/Accounts/UpdateSubscriber";
import { toastError, toastSuccess } from "../../utils/toastrResponse";
import useAxios from "../../hooks/useAxios";
import { Form } from "reactstrap";
import { createAccount } from "../../utils/roles";
const Account = () => {
  const [account, setAccount] = useState();
  const [subscriberData, setSubscriberData] = useState();
  const [subscriberModal, setSubscriberModal] = useState(false);
  const [accountModal, setAccountModal] = useState(false);
  const [createBillModal, setCreateBillModal] = useState(false);
  const [createPaymentModal, setCreatePaymentModal] = useState(false);
  const [showReceipt, setShowReceipt] = useState(false);
  const [row, setRow] = useState();
  const [showAddHouseModal, setShowAddHouseModal] = useState(false);
  const { accountId } = useParams();
  const roles = JSON.parse(localStorage.getItem("roles"));
  const user = JSON.parse(localStorage.getItem("user"));
  const queryClient = useQueryClient();
  const [amount, setAmount] = useState(0);
  const [phonNumber, setPhoneNumber] = useState("");
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [housedPayload, setHousePayload] = useState({})
  const [selectedChoice, setSelectedChoice] = useState(null)
  const [house, setHouse] = useState([])
  const [houseId, setHouseId] = useState(null)
  const [categories, setCategories] = useState([])
  const [ loading,setLoading] = useState(false)
  const axiosInstance = useAxios();
  const locations = JSON.parse(localStorage.getItem("agentLocations"));
  console.log(locations);
  let userLocations = [];
  locations.forEach((location) => {
    userLocations = [...userLocations, location[4]];
  });
  const fetchCategoires = async () => {
    const res = await axiosInstance.get(`/houses/categories`);
    setCategories(res.data)
  }
  const fetchHouse = async () => {
    const res = await axiosInstance.get(`/houses/${houseId}`);
    setHouse(res.data);
  };
  useEffect(()=>{fetchCategoires()},[])
  const handleOnChange = (e) => {
    const { name } = e.target;
    const { value } = e.target;
    setHousePayload({
      ...housedPayload,
      [name]: value,
    });
  };
  const handleAddHouse = async (e) => {
    e.preventDefault()
    setLoading(true)
    const payload = {
      ...housedPayload,
      accountId,
      statusId: 1,
      ownerSubscriberId:subscriberData[0]?.id,
    };
    const houseCategory = categories.find(
      (category) => category.id == payload.categoryId
    );
    const updatePayload = {
      ...house,
      accountId,
      securityFeeAmount: payload?.securityFeeAmount,
      category:houseCategory
    };
    try {
      const res =
        selectedChoice == 2
          ? await axiosInstance.put("/houses", updatePayload)
          : await axiosInstance.post("/houses", payload);
      if (res.status >= 200 && res.status <= 300) {
        setShowAddHouseModal(false);
        queryClient.invalidateQueries("house-for-account");
        setLoading(false);
      }
      
    } catch (error) {
      setLoading(false)
      toastError(error)
    console.error('Error during creating account:', error);
  }
  };
  const handleShowModal = (type) => {
    if (type === "bill") {
      setCreateBillModal(true);
    } else if (type === "subscriber") {
      setSubscriberModal(true);
    } else if (type === "account") {
      setAccountModal(true);
    } else {
      setCreatePaymentModal(true);
    }
  };
  const handleCloseModal = (type) => {
    if (type === "bill") {
      setCreateBillModal(false);
    } else if (type === "subscriber") {
      setSubscriberModal(false);
    } else if (type === "account") {
      setAccountModal(false);
    } else {
      setCreatePaymentModal(false);
    }
  };
  const updateModal = () => handleShowModal("subscriber");
  // const { data } = useFetchData(
  //   ["fetch-account"],
  //   `accounts/${accountId}`,
  //   true,
  //   user
  // );
  const { data } = useFetchData(
    ["fetch-account", accountId], // Unique & stable key
    `accounts/${accountId}`
  );
  useEffect(() => {
    if (data) {
      setAccount(data);
      const { subscriberId } = data;
      fetchSubscriber(subscriberId);
    }
  }, [data]);
  const fetchSubscriber = async (subscriberId) => {
    const subscriberResponse = await axiosInstance(
      `/subscribers/${subscriberId}`
    );
    if (
      !subscriberResponse.status >= 200 &&
      !subscriberResponse.status <= 300
    ) {
      throw new Error("Failed to fetch subscriber data");
    }
    const subscriberData = subscriberResponse.data;
    setSubscriberData([subscriberData]);
  };
  const handleScronize = async () => {
    await axiosInstance({
      url: `/accounts/${accountId}/synchronize`,
      method: "PUT",
      headers: {
        Accept: "application/json",
        "content-Type": "application/json",
      },
    })
      .then((res) => {
        if (res.status <= 200 && res.status <= 300) {
          toastSuccess("Account syncronized");
          queryClient.invalidateQueries("fetch-account");
          queryClient.invalidateQueries("bills-for-account");
        }
      })
      .catch((err) => {
        console.log("Something went wrong:", err);
      });
  };
  const makePayment = async (e) => {
    e.preventDefault();
    const paymentPayload = {
      accountId,
      amount,
      phoneNumber: `25${phonNumber}`,
      collectionAccountId: 1,
      messsage: "Umutekano 2",
    };
    await axiosInstance({
      url: `/payments/collections`,
      method: "POST",
      headers: {
        Accept: "application/json",
        "content-Type": "application/json",
      },
      data: paymentPayload,
    })
      .then((res) => {
        if (res.status <= 200 && res.status <= 300) {
          toastSuccess("Payment initiated");
          setShowPaymentModal(false);
        }
      })
      .catch((err) => {
        console.log("Something went wrong:", err);
        toastError("Could not initiate payment");
      });
  };
  return (
    <div className='ml-2 mr-2 mt-3'>
      <div className='card-header d-flex justify-content-center custom-btn-color'>
        <h3 className='font-family' style={{ color: "#FFF", fontWeight: 600 }}>
          Account Details
        </h3>
      </div>
      <AccountDetails account={account} />
      <div className='d-flex justify-content-center'>
        {roles?.some((role) => role.id === editAccount) && (
          <Button
            className='custom-btn-color mr-2'
            onClick={() => handleShowModal("account")}
          >
            Edit Account
          </Button>
        )}
        {roles?.some((role) => role.id === editBill) && (
          <Button
            className='custom-btn-color'
            onClick={() => handleShowModal("bill")}
          >
            Add Bill
          </Button>
        )}
        {roles?.some((role) => role.id === editPayment) && (
          <Button
            className='ml-2 custom-btn-color'
            onClick={() => handleShowModal("payment")}
          >
            Add Payment
          </Button>
        )}
        {roles?.some((role) => role.id === createAccount) && (
          <Button
            className='custom-btn-color ml-2'
            type='submit'
            onClick={() => setShowAddHouseModal(true)}
          >
            Add House
          </Button>
        )}
        <Button className='ml-2 custom-btn-color' onClick={handleScronize}>
          <MdRefresh className='mb-1' /> Syncronize
        </Button>
        {/* <Button
          className='ml-2 custom-btn-color'
          onClick={() => setShowPaymentModal(true)}
        >
          {" "}
          Request Payment
        </Button> */}
      </div>
      <CreateBill
        show={createBillModal}
        onHide={() => handleCloseModal("bill")}
        accountId={accountId}
      />
      <CreatePayment
        show={createPaymentModal}
        onHide={() => handleCloseModal("payment")}
        accountId={accountId}
      />
      {/* Subscriber details section */}
      <AccountOwner ownerData={subscriberData} showUpdateModal={updateModal} />
      {/* Houses Section */}
      <HouseForAccount accountId={accountId} />
      {/* Bills section */}
      <BillsForAccount accountId={accountId} />
      {/* Payment section */}
      <PaymentForAccount
        accountId={accountId}
        showReceipt={setShowReceipt}
        setRow={setRow}
      />
      {/* Update Account modal */}
      <UpdateAccountDetails
        show={accountModal}
        onHide={() => handleCloseModal("account")}
        accountData={account}
        refreshFunction={fetchSubscriber}
      />
      <UpdateSubsriber
        show={subscriberModal}
        onHide={() => handleCloseModal("subscriber")}
        subscriber={subscriberData}
        refreshFunction={fetchSubscriber}
      />
      {/* Modal to let user pay */}
      <Modal
        aria-labelledby='contained-modal-title-vcenter'
        centered
        show={showPaymentModal}
      >
        <Modal.Header closeButton onClick={() => setShowPaymentModal(false)}>
          <Modal.Title>Make Payment</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={makePayment}>
            <label className='ml-2 mt-2'>Phone number</label>
            <input
              type='number'
              className='form-control'
              placeholder='078xxxxxxx/079xxxxxxx'
              name='text'
              value={phonNumber}
              onChange={(e) => setPhoneNumber(e.target.value)}
              required
            />
            <label className='ml-2 mt-2'>Amount</label>
            <input
              type='number'
              className='form-control'
              placeholder='Enter amount to pay'
              name='amount'
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
              required
            />
            <div className='d-flex justify-content-center'>
              <Button className='custom-btn-color' type='submit'>
                Pay
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
      {/* Add house to account */}
      <Modal
        aria-labelledby='contained-modal-title-vcenter'
        centered
        show={showAddHouseModal}
      >
        <Modal.Header closeButton onClick={() => setShowAddHouseModal(false)}>
          <Modal.Title>Ongera inzu kuriyi konti</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleAddHouse}>
            <label className='ml-2 mt-2'>Hitamo inzu</label>
            <select
              className='form-control'
              name='choice'
              onChange={(e) => setSelectedChoice(e.target.value)}
              required
            >
              <option value=''>Hitamo inzu</option>
              <option value={1}>Inzu nshya</option>
              <option value={2}>Inzu isanzwemo</option>
            </select>
            {selectedChoice == 2 && (
              <>
                <label className='ml-2 mt-2'>Umubare w'inzu</label>
                <input
                  type='number'
                  className='form-control'
                  placeholder='Injiza umubare uranga inzu'
                  onChange={(e) => setHouseId(e.target.value)}
                  onBlur={() => {
                    if (selectedChoice == 2) {
                      fetchHouse();
                    }
                  }}
                  required
                />
              </>
            )}
            <label className='ml-2 mt-2'>Hitamo umudugudu</label>
            <select
              className='form-control'
              name='locationId'
              onChange={handleOnChange}
              // required
            >
              <option value=''>Hitamo umudugudu</option>
              {userLocations?.map((location) => (
                <option value={location?.id}>{location?.name}</option>
              ))}
            </select>
            <label className='ml-2 mt-2'>Ubwoko bw'inzu</label>
            <select
              className='form-control'
              name='categoryId'
              onChange={handleOnChange}
              required
            >
              <option value=''>Hitamo ubwoko bw'inzu</option>
              {categories?.map((category) => (
                <option value={category?.id}>{category?.name}</option>
              ))}
            </select>
            <label className='ml-2 mt-2'>Amafaranga y'ishyura kukwezi</label>
            <input
              type='number'
              className='form-control'
              placeholder="Amafaranga y'ishyura kukwezi"
              name='securityFeeAmount'
              onChange={handleOnChange}
              required
            />
            <div className='d-flex justify-content-center'>
              <Button className='custom-btn-color' type='submit'>
                {loading ? "Submitting..." : "Ongeraho inzu"}
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    </div>
  );
};
export default Account;
